import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/logo/gordian_white.svg'


const _hoisted_1 = {
  key: 0,
  class: "min-h-screen bg-gray-900 z-50 w-full text-white flex items-center justify-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-8",
  src: _imports_0,
  loading: "eager",
  alt: "Gordian Software logo"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "min-h-full"
}
const _hoisted_5 = { class: "bg-gray-100 min-h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardNav = _resolveComponent("DashboardNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (!$setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_DashboardNav),
          _createElementVNode("main", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}